import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDepartments } from '../../../../interface/interfaces';

interface IInitialState {
    inDepartment: IDepartments[];
    outDepartment: IDepartments[];
    rootDepartment: IDepartments;
}

const initialState: IInitialState = {
    inDepartment: [],
    outDepartment: [],
    rootDepartment: {
        DepartmentId: 0,
        DepartmentName: '',
        Label: '',
        In: [],
        Out: [],
        Status: 'UNKNOWN',
        Actions: [],
    },
};

const arangeDepartmenstSlice = createSlice({
    name: 'arangeDepartments',
    initialState,
    reducers: {
        setInDepartment: (state: IInitialState, action: PayloadAction<IDepartments[]>) => {
            state.inDepartment = action.payload;
        },
        setOutDepartment: (state: IInitialState, action: PayloadAction<IDepartments[]>) => {
            state.outDepartment = action.payload;
        },
        setRootDepartment: (state: IInitialState, action: PayloadAction<IDepartments>) => {
            state.rootDepartment = action.payload;
        },
    },
});

export default arangeDepartmenstSlice.reducer;
export const { setInDepartment, setOutDepartment, setRootDepartment } = arangeDepartmenstSlice.actions;
